import {
  useMemo
} from 'react';
import {
  useLocation
} from 'react-router-dom';
import {
  PaymentMethod
} from '@entities/payments';

export type WithdrawCoinsFailedNavigationParams = {
  paymentId?: Maybe<string>;
  accountNumber?: Maybe<string>;
  purchaseAmount?: Maybe<number>;
  paymentMethod?: Maybe<PaymentMethod>;
};

export type UseWithdrawCoinsFailedParams = {
  hasDetails: boolean;
  hasPaymentMethod: boolean;
  paymentMethod?: Maybe<PaymentMethod>;
  checkoutDetails: {
    paymentId?: Maybe<string>;
    accountNumber?: Maybe<string>;
    purchaseAmount?: Maybe<number>;
  };
};

export const useWithdrawCoinsFailedParams = (): UseWithdrawCoinsFailedParams => {
  const { state } = useLocation();

  return useMemo(() => {
    const params = (state || {}) as Partial<WithdrawCoinsFailedNavigationParams>;

    const paymentMethod = params?.paymentMethod ?? null;
    const checkoutDetails = {
      paymentId: params.paymentId ?? null,
      accountNumber: params.accountNumber ?? null,
      purchaseAmount: params.purchaseAmount ?? null,
    };

    const hasPaymentMethod = Boolean(paymentMethod);
    const hasDetails = Boolean(
      checkoutDetails.paymentId ||
      checkoutDetails.accountNumber ||
      checkoutDetails.purchaseAmount
    );

    return {
      hasDetails,
      paymentMethod,
      hasPaymentMethod,
      checkoutDetails,
    } as UseWithdrawCoinsFailedParams;
  }, [state]);
};